import React, { useContext } from 'react';

import { mdiMenu } from '@mdi/js';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { DownloadContext } from './context/DownloadContext';
import { ABOUT, CONTACT_SUPPORT, CONTACT_US2 } from '../../constants/urls';
import ImgClassLogo from '../../images/class-logo-full.svg';
import ButtonMenu from '../common/buttonMenu/ButtonMenu';
import ButtonMenuItem from '../common/buttonMenu/ButtonMenuItem';

const StyledButtonMenu = styled(ButtonMenu)`
    svg {
        color: ${(props) => props.theme.colors.text.secondary};
    }
`;

const Container = styled('div')`
    display: flex;
    width: 100%;

    #header-logo {
        max-width: 137px;
        max-height: 32px;
    }

    #header-links {
        display: flex;
        margin-left: 48px;
        column-gap: 48px;
        align-items: center;
    }

    #header-burger-download {
        display: flex;
        margin-left: auto;
    }

    #button-custom-menu-header-burger-menu {
        display: none;
    }

    // Responsive stuff.

    @media only screen and (max-width: 768px) {
        #header-logo {
            max-width: 100px;
            max-height: 30px;
        }

        #header-links {
            display: none;
        }

        #button-custom-menu-header-burger-menu {
            display: inline-flex;
        }
    }
`;

const Header: React.FC = () => {
    const { t } = useTranslation('class');

    const { downloadURL, canDownload } = useContext(DownloadContext);

    return (
        <Container>
            <img id="header-logo" src={ImgClassLogo} alt="" role="presentation" />
            <div id="header-links">
                <a href={CONTACT_SUPPORT}>{t('support-2')}</a>
                <a href={CONTACT_US2}>{t('contact-us-2')}</a>
            </div>
            <div id="header-burger-download">
                <StyledButtonMenu
                    id="header-burger-menu"
                    ariaLabel={t('main-links')}
                    icon={mdiMenu}
                    variant="text"
                    handleItemClick={(e) => {
                        window.location.href = e.currentTarget.dataset.href as string;
                    }}
                >
                    <ButtonMenuItem data-href={ABOUT}>{t('about-2')}</ButtonMenuItem>
                    <ButtonMenuItem data-href={CONTACT_SUPPORT}>{t('support-2')}</ButtonMenuItem>
                    <ButtonMenuItem data-href={CONTACT_US2}>{t('contact-us-2')}</ButtonMenuItem>
                </StyledButtonMenu>
                {canDownload && (
                    <Button
                        variant="outlined"
                        onClick={() => {
                            window.location.href = downloadURL;
                        }}
                    >
                        {t('download-class-short')}
                    </Button>
                )}
            </div>
        </Container>
    );
};

export default Header;
